import { useRecoilState } from "recoil";
import { arvoreState } from "../atom";

const useArvoreState = () => {
    return useRecoilState(arvoreState);
};

export default useArvoreState;